module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-width-1-2@m uk-flex uk-flex-stretch uk-margin-remove uk-flex-wrap",
    attrs: {
      "id": "notifications"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "notificaions-holder uk-width"
  }, _vm._l((_vm.notifications), function(notification) {
    return _c('div', {
      staticClass: "notification uk-width uk-margin-bottom uk-margin-remove-top uk-box-shadow-small uk-box-shadow-hover-large uk-padding uk-grid uk-margin-remove-left uk-padding-small",
      class: {
        unread: _vm.isRead(notification)
      }
    }, [_c('span', {
      staticClass: "uk-flex uk-flex-middle uk-width-1-6 uk-padding-remove-horizontal",
      attrs: {
        "uk-icon": "icon: info; ratio: 1.5;"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "uk-width-5-6 uk-padding-remove-horizontal"
    }, [_c('article', {
      staticClass: "notification-title uk-width",
      on: {
        "click": function($event) {
          return _vm.OpenModal(notification.id)
        }
      }
    }, [_c('h4', {
      staticClass: "text-ellipsis two-line",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_vm._v(_vm._s(notification.title))]), _vm._v(" "), _c('span', {
      staticClass: "text-ellipsis three-line"
    }, [_vm._v(_vm._s(notification.messagetxt))])]), _vm._v(" "), _c('footer', {
      staticClass: "uk-link-muted uk-width uk-padding-remove-horizontal uk-margin-small-top"
    }, [_c('span', {
      staticClass: "time-added"
    }, [_vm._v("Dodane " + _vm._s(_vm._f("formatDatefrom")(notification.data)))]), _vm._v("\n          |\n          "), _c('a', {
      staticClass: "see-more",
      on: {
        "click": function($event) {
          return _vm.OpenModal(notification.id)
        }
      }
    }, [_vm._v("Zobacz cały komunikat")]), _vm._v(" "), _c('div', {
      attrs: {
        "id": 'see-more-modal-' + notification.id,
        "uk-modal": ""
      }
    }, [_c('div', {
      staticClass: "uk-modal-dialog uk-modal-body"
    }, [_c('h2', {
      staticClass: "uk-modal-title"
    }, [_vm._v(_vm._s(notification.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(notification.messagetxt))]), _vm._v(" "), _c('p', {
      staticClass: "uk-text-right"
    }, [_c('button', {
      staticClass: "uk-button uk-button-default uk-modal-close",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("Zamknij")]), _vm._v(" "), (notification.read === false) ? _c('button', {
      staticClass: "uk-button uk-button-danger uk-modal-close",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.MarkAsRead(notification.id)
        }
      }
    }, [_vm._v("Przeczytane")]) : _vm._e()])])])])])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "uk-width uk-margin-remove uk-padding-remove uk-heading-line"
  }, [_c('h3', [_vm._v("Komunikaty")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52d3a5ea","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/notifications.vue
// module id = 242
// module chunks = 1